import { create, show, useModal } from "@ebay/nice-modal-react";

import ConfirmationModal from "ds/components/ConfirmationModal";
import { ConfirmationModalMessage } from "ds/components/ConfirmationModal/Message";

type TableSettingsResetConfirmationProps = {
  onReset: () => void;
};

const TableSettingsResetConfirmation = create(function TableSettingsResetConfirmation({
  onReset,
}: TableSettingsResetConfirmationProps) {
  const handleOnReset = () => {
    onReset();
    modal.hide();
  };

  const modal = useModal();

  return (
    <ConfirmationModal
      title="Reset list configuration"
      confirmationButtonLabel="Reset"
      onConfirm={handleOnReset}
      shouldIgnoreOutsideClick
    >
      <ConfirmationModalMessage>
        Resetting this list to default configuration will clear column order, visibility and size.
        Are you sure you want to reset?
      </ConfirmationModalMessage>
    </ConfirmationModal>
  );
});

export const showResetConfirmation = (props: TableSettingsResetConfirmationProps) =>
  show(TableSettingsResetConfirmation, props);
